"use client";

import { LicenseInfo } from "@mui/x-license";

export default function MuiXLicense({ licenseKey }: { licenseKey: string }) {
  LicenseInfo.setLicenseKey(licenseKey);
  return null;
}
